module.exports = __webpack_public_path__ + "img/Dashboard.45dd7ba6.svg";